


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { SurveyElementsUnion } from '@/models/survey-elements-union';
import { SurveyTextFieldElement } from '@/models/survey-elements/text-field-element';
import FormControl from '@/components/FormControl.vue';
import { COMPONENT_TYPES } from '@/models/enums/component-types.enum';
import ComponentWrapper from '@/components/ComponentWrapper.vue';

type WidgetWrapperType = 'div' | 'FormControl';
@Component({
  name: 'widget-wrapper',
  components: {
    FormControl,
    ComponentWrapper,
  },
})
export default class WidgetWrapper extends Vue {
  @Prop({ type: Object, required: true }) field!: SurveyElementsUnion;
  @Prop({ type: Boolean, required: false }) isStaticError!: boolean;

  private get fieldValue(): Record<string, any> {
    return this.field.isAnswerable ? { value: this.field.value } : {};
  }

  private get fieldProps(): { field: SurveyElementsUnion; value?: any } {
    return { ...this.fieldValue, field: this.field };
  }
  private get showCustomValidationComponent(): boolean {
    return this.field.isAnswerable && this.isCustomValidationAllowed;
  }

  private get isCustomValidationAllowed(): boolean {
    return 'customValidation' in this.field
      ? !!this.field.customValidation
      : false;
  }
  private get isRequired(): boolean {
    return 'isRequired' in this.field ? !!this.field.isRequired : false;
  }
  private get validationRequired(): boolean {
    return (
      this.isRequired ||
      ('type' in this.field &&
        (this.field.type === 'number' || this.field.type === 'email'))
    );
  }
  private get wrapperType(): WidgetWrapperType {
    return this.validationRequired ? 'FormControl' : 'div';
  }

  private get shouldFillEmptySpace(): boolean {
    return (
      this.field.elementType === COMPONENT_TYPES.AI_GENERATED_TEXT_AREA_ELEMENT
    );
  }

  private get wrapperProps(): Record<string, string | boolean> {
    return this.validationRequired
      ? {
          vid: `${this.field.elementType}_${this.field.id}`,
          rules: this.isRequired
            ? 'required'
            : (this.field as SurveyTextFieldElement).type,
          customValidation: this.isCustomValidationAllowed,
        }
      : {};
  }
}
